"use client"

import {
  CircleCheck,
  CircleX,
  Info,
  Loader2Icon,
  TriangleAlert,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      icons={{
        success: <CircleCheck className="size-4" />,
        info: <Info className="size-4" />,
        warning: <TriangleAlert className="size-4" />,
        error: <CircleX className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          // Sora-spec toast surface: subtle-dark wash + hairline edge, matches
          // the rest of the rebrand's elevation doctrine (no shadows here either).
          "--normal-bg": "var(--surface-subtle-dark-strong)",
          "--normal-text": "var(--text-on-dark-primary)",
          "--normal-border": "var(--hairline-strong)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
